import React from 'react';

//Component
import { Button, LinearProgress } from '@mui/material';

//Css
import styled from 'styled-components';

const Root = styled.div`
  &&& {
    height: 7px;
    width: 100%;
    background-color: #e0e0de;
    border-radius: 50px;
  }
`;

const Container = styled.div`
  &&& {
    height: 100%;
    width: ${props => props.progress}%;
    background-color: #01b4a2;
    border-radius: inherit;
    text-align: right;
  }
`;

const Progress = styled.span`
  &&& {
    padding: 5;
    color: white;
    font-weight: bold;
  }
`;

export const RenderProgressBar = props => {
  const { row } = props;
  const totalRubricGrades = row.rubricGrade.length;
  const gradedRubrics = row.rubricGrade.filter(rubric => rubric.isGraded).length;

  return (
    <Root>
      <Container progress={(gradedRubrics / totalRubricGrades)*100}>
        <Progress />
      </Container>
    </Root>
  );
};
